// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

// Permissions
export const Permissions = {
    WRITE_AUCTIONS: 'write:auctions',
    WRITE_MED_BILLING: 'write:med_billing',
    WRITE_PERFORMANCE: 'write:performance',
    WRITE_WORKLIST: 'write:worklist',
} as const;

export const RouteCodes = {
    CONTRACT: 'CONTRACT',
    MEM_PREF: 'MEM_PREF',
    ACCEPT: 'ACCEPT',
    RND_ROBIN: 'RND_ROBIN',
} as const;

export const PlaceOfServiceCode = {
    FACILITY: 'FACILITY',
    HOME: 'HOME',
    INFU_INFU: 'INFU_INFU',
    INFU_SPEC: 'INFU_SPEC',
    PHYS_PHYS: 'PHYS_PHYS',
    PHYS_SPEC: 'PHYS_SPEC',
} as const;

// Frontend only status for handling ROFR/FOR referrals
export const PendingReferralStatus = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    PENDING: 'PENDING',
} as const;

export const ClaimBasedAuthIdPrefix = 'FMHX';

export const YesNoIDK = {
    YES: 'Y',
    NO: 'N',
    IDK: 'U',
} as const;

export const YesNoRadioOptions = [
    {
        value: YesNoIDK.YES,
        text: 'Yes',
    },
    { value: YesNoIDK.NO, text: 'No' },
];

export const YesNoIDKRadioOptions = [
    ...YesNoRadioOptions,
    { value: YesNoIDK.IDK, text: "I don't know" },
];
